/* Lymphoria · fecha estimada de llegada: cuenta días de lunes a sábado (sin domingos). */
(function () {
  'use strict';
  var DAYS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
  var MONTHS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  function label(date) {
    return DAYS[date.getDay()] + ' ' + date.getDate() + ' de ' + MONTHS[date.getMonth()];
  }
  function addDeliveryDays(base, days) {
    var d = new Date(base.getFullYear(), base.getMonth(), base.getDate());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) added += 1;
    }
    return d;
  }
  function run() {
    var now = new Date();
    document.querySelectorAll('[data-sp-delivery]').forEach(function (el) {
      var template = el.getAttribute('data-template') || '';
      var out = el.querySelector('[data-sp-delivery-text]') || el;
      if (!template.trim()) return;
      // A confirmed static delivery window must not be hidden or converted to dates.
      if (template.indexOf('{min}') === -1 && template.indexOf('{max}') === -1) {
        out.textContent = template;
        el.hidden = false;
        return;
      }
      if (template.indexOf('{min}') === -1 || template.indexOf('{max}') === -1) return;
      var min = parseInt(el.getAttribute('data-min'), 10);
      var max = parseInt(el.getAttribute('data-max'), 10);
      if (!(min > 0) || !(max >= min)) return;
      var first = addDeliveryDays(now, min);
      var last = addDeliveryDays(now, max);
      var firstLabel = first.getMonth() === last.getMonth() ? DAYS[first.getDay()] + ' ' + first.getDate() : label(first);
      var text = template.replace('{min}', firstLabel).replace('{max}', label(last));
      out.textContent = text;
      el.hidden = false;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();